@import "../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";
@import "../common/styles.scss";
@import "../../../global/temporary-mercury-overrides/_button.scss";

// TODO: this should be a class on Mercury.
// Not sure if applying ".field-group" is the right thing to do.
$commonRowGap: var(--spacing-gap-l);

:host {
  display: grid;
  grid-template-columns: max-content 1fr;
  block-size: 100%;
  overflow: auto;
}

.sidebar {
  background-color: transparent !important; // TODO: Apply elevation classes on Mercury.
  border-inline-end: var(--section-common-border);
}

.sidebar::part(expand-button) {
  border-radius: var(--control-border-radius);
}

gx-ide-select-kb-items {
  --search-input-max-inline-size: 300px;
  opacity: 0;
  transition: opacity var(--timing-fast);
}
gx-ide-select-kb-items.sidebar-expanded {
  opacity: 1;
}

ch-tabular-grid.tabular-grid--empty::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}

ch-tabular-grid-rowset-empty {
  position: relative; // makes this the bounder element for the loader
}

.main {
  display: grid;
  grid-template-rows: max-content 1fr;
  grid-row-gap: $commonRowGap;
  overflow: auto;
}
.main__header {
  display: grid;
}
.main__content {
  position: relative;
  overflow: auto;
  display: grid;
  grid-template-rows: 1fr max-content 2fr;
  grid-row-gap: $commonRowGap;
}

.tabular-grid {
  overflow: auto;
}

/*SECOND GRID*/
.search-filter {
  display: grid;
  grid-template-columns: 1fr max-content max-content;
  gap: var(--spacing-gap-l);
}

.action-buttons {
  justify-self: flex-end;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-areas:
    "from from to to type type"
    "user user user revision revision revision";
  padding-block-start: $commonRowGap;
}

.filters-container {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows var(--timing-fast);
}

.filters-container-visible {
  grid-template-rows: 1fr;
}

.filters-container > div {
  overflow: hidden;
}

.field-from {
  grid-area: from;
}

.field-to {
  grid-area: to;
}
.field-type {
  grid-area: type;
}
.field-user {
  grid-area: user;
}
.field-revision {
  grid-area: revision;
}

// commits grid "comment" column
@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".commits-grid",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-min-inline-size: 200px,
  $tabular-grid-affected-columns-nth-list: (
    2
  )
);

// affected objects grid "description" column
@include tabular-grid-cell-layout(
  $tabular-grid-selector: ".affected-objects-grid",
  $tabular-grid-cell-node-type: "text",
  $tabular-grid-cell-min-inline-size: 200px,
  $tabular-grid-affected-columns-nth-list: (
    5
  )
);
